module.exports = __webpack_public_path__ + "img/jcdecaux.aa7d344d.svg";